import { asyncRouterMap } from '../router/index';

// 引入模块
import * as eduInfo from './modules/education';
import * as formMap from './modules/formMap';
export interface ICustomerAppKey {
  appKey: string;
  appName: string;
  appSecret: string;
  id: number;
  isActive: number;
  isTest: number;
  orgId: number;
  userId: number;
}

export interface IOrganization {
  dataFrom: string;
  isAdmin: number;
  id: number;
  isActive: number;
  isOwner: number;
  orgName: string;
  subject: string;
  titleId: number;
  orgUsers: IOrgUsers[];
}

export interface IOrgUsers {
  data: IOrgUserData[];
  email: string;
  isActive: number;
  isOwner: number;
  nickname: string;
  phone: string;
  subject?: string;
  titleId?: string;
  userId: number;
  wechat: boolean;
}

export interface IOrgUserData {
  id: number;
  name: string;
}

export interface IUser {
  accounts: IUserAccount[];
  business: number;
  externalUserType?: number;
  headImageUrl: string;
  male: number;
  nickname: string;
  userId: number;
  orgs: IOrgData[];
}

export interface IOrgData {
  isAdmin: number;
  isActive: number;
  isFree: number;
  isOwner: number;
  orgId: number;
  orgName: string;
  subject: string;
  titleId: number;
  wordPoints: number;
  wordToFbdTypes: string;
  aigcToolConfig: string;
  departments: IDepartments[];
  [key: string]: number | string | IDepartments[];
}

export interface IDepartments {
  id: number;
  orgId: number;
  departmentName: string;
}

export interface IUserAccount {
  userType: number;
  username: string;
  validated: number;
}

const state: any = {
  user: null,
  routers: asyncRouterMap,
  uploading: false,
  order_id: '',
  customerAppKey: null,
  formMap: formMap,
  organization: null,
  ...eduInfo,
  xdocPlan: null,
  OrgInfo: null,
  stage: null,
  subject: null
};

export default state;
